import React, { useState } from "react"
import { createPortal } from "react-dom"
import { Box } from "@mui/material"
import { REPORT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { ReportIconsLegend } from "Pages/ReportsAlerts/Reports/@components"
import { reportListData } from "Pages/ReportsAlerts/Reports/@signals"
import ReportsRatingPageContent from "Pages/ReportsAlerts/Reports/Rating/Page"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import RatingReportsDemoData from "./VirtualTour/DemoData"


export default function RatingReports() {
	const [tourActive, setTourActive] = useState(false)
	const showDemoData = tourActive && !reportListData.value?.length

	return <PageWrapper
		head={`DS Rentacar | ${REPORT_ROUTES.RATING_TITLE}`}
		title={REPORT_ROUTES.RATING_TITLE}
		isEmpty={false}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<ReportIconsLegend/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<ReportsRatingPageContent hideCrudTable={showDemoData}/>
		{showDemoData && <RatingReportsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
